<template>
	<span>
		<el-tooltip v-if="inputVisible" effect="light" :content="digitUppercase2(inputValue)" placement="top-start">
		<input ref="input" style="height: 22px; width: 100px" type="Number"
           v-model.number.trim="inputValue" @blur="handleInputConfirm" @keyup.enter="handleInputConfirm">
		</el-tooltip>

		<span v-else style="color: red;" @click="showInput">{{ formatValue }}</span>
	</span>
</template>

<script>
  import {digitUppercase2} from '@/utils/misc'

  export default {
    name: 'type-clause',
    props: {
      variable: Object
    },
    computed: {
      formatValue: function () {
        let formatedValue
        if (this.inputValue >= 10000) {
          formatedValue = parseInt(this.inputValue) / 10000 + '万'
        } else if (this.inputValue < 1 && this.inputValue > 0) {
          formatedValue = parseFloat((this.inputValue * 100).toPrecision(12)) + '%'
        } else {
          formatedValue = parseFloat(this.inputValue) + ''
        }

        return formatedValue
      }
    },
    data() {
      return {
        inputVisible: false,
        inputValue: this.variable.value
      }
    },
    methods: {
      digitUppercase2,
      showInput() {
        this.inputVisible = true
        this.$nextTick(() => {
          this.$refs.input.focus()
        })
      },
      handleInputConfirm() {
        if (!this.inputValue) {
          this.$message.error('变量[' + this.variable.code + ']的默认值不能为空')
          this.$nextTick(() => {
            this.$refs.input.focus()
          })
          return
        }
        this.variable.value = this.inputValue
        this.$emit('update', this.variable)
        this.inputVisible = false
      }
    }
  }
</script>
